import { DraftStatus } from "authoring/lib/enum/draft-status.mjs"

export function setDraftStatusBadgeColor(status) {
    switch (status) {
        case DraftStatus.EDITING:
            return "authoringInProgress"
        case DraftStatus.SUBMITTED:
            return "authoringProjectSentToLegacy"
        case DraftStatus.APPROVED:
            return "authoringApplied"
        case DraftStatus.REJECTED:
            return "authoringRejected"
        default:
            return ""
    }
}
